import { getItem } from '@propertypal/shared/src/services/local.storage';
import { Profile, WebsiteUser } from '@propertypal/shared/src/types/websiteUser';
import { getNumberWithoutPrefix, getPrefix } from '@propertypal/shared/src/utils/phoneNumber';
import { useEffect } from 'react';

export const PROFILE_STORAGE_KEY = 'formProfile';

export interface FormDetails {
  name: string;
  email: string;
  phoneNumber: string;
  prefix: string;
  phoneNumberNoPrefix: string;
}

const useCachedUser = (profile: WebsiteUser | undefined, callback: (formDetails: FormDetails) => void) => {
  useEffect(() => {
    if (profile) {
      callback({
        name: `${profile.firstName} ${profile.lastName}`,
        prefix: getPrefix(profile.telephone),
        phoneNumberNoPrefix: getNumberWithoutPrefix(profile.telephone),
        email: profile.email,
        phoneNumber: profile.telephone,
      });
    } else {
      const cache = getItem<Profile | null>(PROFILE_STORAGE_KEY);

      if (cache) {
        callback({
          name: cache.name,
          phoneNumber: cache.phoneNumber,
          prefix: getPrefix(cache.phoneNumber),
          phoneNumberNoPrefix: getNumberWithoutPrefix(cache.phoneNumber),
          email: cache.email,
        });
      }
    }
  }, []);
};

export default useCachedUser;
